import React from "react";
import { useNavigation } from "@react-navigation/native";
import { Button01 } from "@src/components/button";
import { Text, View } from "react-native";
import { ResetContext } from "./provider";
import useStyles from "./styles.css";
import SVGIcon from "@assets/svg";
import _ from "lodash";

function UpdateSuccess() {
  const styles = useStyles();
  const navigation = useNavigation<any>();
  const { data } = React.useContext(ResetContext);

  if(_.isEmpty(data)){
    return null;
  }

  return (
    <View style={[styles.container]}>
      <SVGIcon name="success" />
      <Text style={[styles.t_success]} >Update Password Cofirmation</Text>
      <Text style={[styles.t_verify]} >You’ve successfully updated your password for the following:</Text>
      <Text style={[styles.t_verify]} >Gameworkz Rewardz & Gameworkz Fortune 8</Text>
      <Button01 
        onPress={() => navigation.navigate("Signin")}
        label="LOG IN NOW" style={styles.btn_dashboard}
        labelStyle={styles.label_dashboard} />
    </View>
  );
}

export default UpdateSuccess;
